import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "../CaseSelector/CaseSelector.css";
import { numberWithCommas } from "../../util";
import axios from "axios";
import { apiUri } from "../../config";
import styled from 'styled-components';
import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

import { FaChevronDown, FaChevronUp,FaSearch } from "react-icons/fa";

const state = {
	classNameCaseIdnull: "CaseSelectorEntryCaseIdnull",
	classNameCaseId: "CaseSelectorEntry"
};

const PaginationList = styled.ul`
	float: right;
	color: white;
	font-family: "GothamLight";
	display: flex;
	padding-left: 0;
	list-style: none;
	border-radius: .25rem;
	
	@media print {
		color: black;
	}
`;

const PaginatedItem = styled.li`
	padding-right: 4px;
	font-size: 14px;
	cursor: pointer;
	// display: ${props => props.disabled ? 'none' : ''};
	display: block;
	// color: #83BED3;
	color: ${props => props.disabled ? '#969292' : '#e6e8e4'};
	// pointer-events: none;
	pointer-events: ${props => props.disabled ? 'none' : 'pointer'};
	opacity: ${props => props.disabled ? '0.6' : '1'};
`;

const SelectedPaginatedItem = styled(PaginatedItem) `
	// color: BLUE;
	color: #83BED3;
`;

class MyCases extends Component {
	constructor(props) {
		super(props);
		this.state = {
			myCasesArray:[],
			currentPage: 1,
			totalCasesPerPages:40,
			sortValue:'',
			sortOrder:'',
			searchValue:''
			
		};

		this.goToCaseHandler = this.goToCaseHandler.bind(this); 
		this.handleClick = this.handleClick.bind(this);
		this.getMyCases = this.getMyCases.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	
	}

	componentWillMount(){
		this.getMyCases() 
	}
	componentDidMount(){
		localStorage.removeItem('searchValue');
		localStorage.removeItem('sortParams');
	}
	getMyCases(){
		axios
			.get(apiUri+"/cases/myCases")
			.then(res =>{
				this.setState({
					myCasesArray: res.data.content
				})
			}
			)
			.catch(err => {
				console.log(err);
			});
	}

	handleClick(event) {
		this.setState({
			currentPage: Number(event)
		});
	}

	goToCaseHandler = caseId => {
		this.props.history.push("/cases/" + caseId);
		sessionStorage.setItem('currentPage',this.state.currentPage)
	};
	
	formatapprox_market_cap_loss = data => {
		if (data) {
			data = data / 1000;
			data = Math.round(data);
			data = numberWithCommas(data);
			data = "$" + data;
			return data;
		} else {
			return "-";
		}
	};

	getProperDate = data => {
 
		if (data) {
			var date = new Date(data);
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString().padStart(2, "0");
			var day = date
				.getDate()
				.toString()
				.padStart(2, "0");
			return month + "-" + day + "-" + year;
		} else {
		return "";
		}
	};

	getOrderDate = data => {
 
		if (data) {
			var date = new Date(data);
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString().padStart(2, "0");
			var day = date
				.getDate()
				.toString()
				.padStart(2, "0");
			return year + "-" + month + "-" + day;
		} else {
		return "";
		}
	};

	handleSorting = (key,order) => {
		if(order==="asc"){
			
			if(key === "classPeriodEnd" || key === "classPeriodStart" || key === "dateFiled"){
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (this.getOrderDate(a[key]) > this.getOrderDate(b[key])) ? 1 :
					((this.getOrderDate(b[key]) > this.getOrderDate(a[key])) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}else{
			
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}   
		}else{
			if(key === "classPeriodEnd" || key === "classPeriodStart" || key === "dateFiled"){
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (this.getOrderDate(a[key]) < this.getOrderDate(b[key])) ? 1 :
					((this.getOrderDate(b[key]) < this.getOrderDate(a[key])) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}else{
			
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}
		}
	}  

	handleSearch() {
		if(this.state.searchValue){
			this.setState({
				myCasesArray:this.state.myCasesArray.filter(item => {
					return (
						(item.caseName
						.toLowerCase()
						.indexOf(this.state.searchValue.toLowerCase()) !== -1) ||
						(item.symbol
						.toLowerCase()
						.indexOf(this.state.searchValue.toLowerCase()) !== -1) || 
						(item.docketId!==null&&item.docketId
						.toLowerCase()
						.indexOf(this.state.searchValue.toLowerCase()) !== -1)
					);
				})
			})
			sessionStorage.setItem('tempSearchValue',this.state.searchValue)
		}
	}
	handleClear() {
		this.setState({ searchValue: '' });
		this.getMyCases()
		sessionStorage.removeItem('tempSearchValue')
	}
	keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleSearch();
		}
	}
	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value })
		if(evt.target.value.length===0){
			this.getMyCases();
		}
	}

	componentDidUpdate(){
		window.onpopstate  = (e) => {
			var tempSearchValue = sessionStorage.getItem('tempSearchValue')
			if(tempSearchValue){
				setTimeout(()=>{
					this.setState({
							myCasesArray:this.state.myCasesArray.filter(item => {
								return (   
										(item.caseName
											.toLowerCase()
											.indexOf(tempSearchValue.toLowerCase()) !== -1) ||
										(item.symbol
											.toLowerCase()
											.indexOf(tempSearchValue.toLowerCase()) !== -1) || 
										(item.docketId!==null&&item.docketId
											.toLowerCase()
											.indexOf(tempSearchValue.toLowerCase()) !== -1)
									);
							})
					})
				},200)

				this.setState({ searchValue: tempSearchValue })
			}
			var currentPage = sessionStorage.getItem('currentPage');
			if(currentPage){
				setTimeout(()=>{
				this.setState({ currentPage: Number(currentPage) })
			},50)
			}
		}
	}

	render() {
		const { currentPage, totalCasesPerPages } = this.state;
		const indexOfLastTodo = currentPage * totalCasesPerPages;
		const indexOfFirstTodo = indexOfLastTodo - totalCasesPerPages;
		const myCasesList = this.state.myCasesArray.slice(indexOfFirstTodo, indexOfLastTodo);
		const pagesToDraw = [];
		const numOfPages = Math.ceil(this.state.myCasesArray.length / totalCasesPerPages);
		for (let page = 1; page <= numOfPages; page++) {
			let currentPageSelection = currentPage === page;
			const p = currentPageSelection ?
				<SelectedPaginatedItem key={page} >
					<a onClick={() => this.handleClick(page)}>{page }</a>
				</SelectedPaginatedItem>
				:
				<PaginatedItem key={page}>
					<a onClick={() => this.handleClick(page)}>{page }</a>
				</PaginatedItem>;
			pagesToDraw.push(p);
		}
		const disabledOnFirstPageClass = currentPage === 1;
		const disabledOnLastPage = currentPage === numOfPages;

		return (
			<div>
			<React.Fragment>
			<div
				style={{ display: "flex", justifyContent: "space-between" }}
				className={"CaseSelectorTitle"}
			>
				<span>My Cases</span>   

				<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					width: "180"
				}}
				>
				<div
					style={{
					position: "relative",
					width: "207px",
					height: "29px",
					top: "-1px",
					backgroundColor: "#83bed3",
					border: "1px solid rgb(90, 154, 176)",
					borderRadius: "14.5px"
					}}
				>
					<input
					id="search"
					type="text"
					className="searchBox"
					onKeyDown={e => this.keyPress(e)}
					value={this.state.searchValue}
					placeholder="Search"
					onChange={this.updateSearchValue}
					/>
					{this.state.searchValue && (
					<span className="clearIcon" onClick={this.handleClear}>
						x
					</span>
					)}
					<FaSearch className="searchBtn" onClick={this.handleSearch} />
				</div>
				</div>   
			</div>
			{myCasesList? (
			<table className={"CaseSelectorTable"}>
			<thead>
				<tr className={"CaseSelectorHeaders"}>
					<th
						className={"CaseSelectorHeader"}
						style={{
							align: "left",
							justifyContent: "space-between",
							textAlign: "left",
							paddingTop: "16px",
							width: "14%"
						}}
					>
						Defendant Co.  
						<span style={{ position: "relative", left: "5px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "caseName" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("caseName","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "caseName" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("caseName","desc")}
								/>
								</div>
							</div>
						</span>
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "6%" }}
					>
						Ticker  
						<span style={{ position: "relative", left: "5px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "symbol" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("symbol","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "symbol" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("symbol","desc")}
								/>
								</div>
							</div>
						</span>
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "7%" }}
						>
						Filing Type
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "10%" }}
						>
						Filing Date    
						<span style={{ position: "relative", left: "5px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "dateFiled" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("dateFiled","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "dateFiled" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("dateFiled","desc")}
								/>
								</div>
							</div>
						</span>
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "10%" }}
						>
						Docket Number
						<span style={{ position: "relative", left: "5px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "docketId" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("docketId","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "docketId" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("docketId","desc")}
								/>
								</div>
							</div>
						</span> 
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "7%" }}
					>
						Claim Life Cycle
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "7%" }}
					>
						Settlement Status
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "10%" }}
					>
						Class Period <br /> Start Date  
						<span style={{ position: "relative", left: "10px",top:-5 }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "classPeriodStart" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("classPeriodStart","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "classPeriodStart" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("classPeriodStart","desc")}
								/>
								</div>
							</div>
						</span>
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "10%" }}
					>
						Class Period <br /> End Date  
						<span style={{ position: "relative", left: "10px",top:-5 }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									this.state.sortValue === "classPeriodEnd" &&
									this.state.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("classPeriodEnd","asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									this.state.sortValue === "classPeriodEnd" &&
									this.state.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => this.handleSorting("classPeriodEnd","desc")}
								/>
								</div>
							</div>
						</span>
					</th>
					<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between", width: "13%" }}
					>
						Approx. Market Cap. Losses (000s)
					</th>     
				</tr>
			</thead>
			<tbody>
				{myCasesList&&myCasesList.map((filledCase, index) => (
				<React.Fragment key={index}>
					<tr onClick={() => filledCase.caseId!==0 && this.goToCaseHandler(filledCase.caseId)}>
						<td
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
							style={{ float: "left", textAlign: "left", width: "80%" }}
						>
							{filledCase.caseName}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{filledCase.symbol}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{filledCase.caseRuleType}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{this.getProperDate(filledCase.dateFiled)}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{filledCase.docketId}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{filledCase.amendClaimsType}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}>
							{filledCase.settlementStatus}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
						
							{this.getProperDate(filledCase.classPeriodStart)}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull:state.classNameCaseId}
						>
							{this.getProperDate(filledCase.classPeriodEnd)}
						</td>
						<td 
							className={filledCase.caseId===0?state.classNameCaseIdnull+"Number":state.classNameCaseId+"Number"}
						>
							{this.formatapprox_market_cap_loss(filledCase.approxMarketCapLoss)}
						</td>
					</tr>   
				</React.Fragment>
				))}
			</tbody>
			</table>
			) : (
				<div className="widthfull">
				<table className="widthfull">
					<tbody>
					<tr>
						<td className="norecords">
						<span>No Records Found</span>
						</td>
					</tr>
					</tbody>
				</table>
				</div>
			)}
			</React.Fragment>

			{/* Custom PaginationList start*/}
				<PaginationList>
				<PaginatedItem disabled={disabledOnFirstPageClass} >
					<a disabled={disabledOnFirstPageClass} onClick={() => this.handleClick(1)}> <FaAngleDoubleLeft style={{
						fontSize: '16px',
						marginTop: '2px',
					}} /> </a>
				</PaginatedItem>
				<PaginatedItem disabled={disabledOnFirstPageClass}>
					<a disabled={disabledOnFirstPageClass} onClick={() => this.handleClick(currentPage - 1)}><FaAngleLeft style={{
						fontSize: '16px',
						marginTop: '2px',
					}} /></a>
				</PaginatedItem>
				{pagesToDraw}
				<PaginatedItem disabled={disabledOnLastPage}>
					<a onClick={() => this.handleClick(currentPage + 1)}><FaAngleRight style={{
						fontSize: '16px',
						marginTop: '2px',
					}} /></a>
				</PaginatedItem>
				<PaginatedItem disabled={disabledOnLastPage}>
					<a onClick={() => this.handleClick(numOfPages)}> <FaAngleDoubleRight style={{
						fontSize: '16px',
						marginTop: '2px',
					}} /> </a>
				</PaginatedItem>
			</PaginationList>
			{/* Custom PaginationList end*/}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
	
	};
};

const mapDispatchToProps = dispatch => {
	return {
	
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(MyCases));



// WEBPACK FOOTER //
// ./src/components/MyCases/MyCases.js